import script from "./EventSearchWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSearchWidget.vue?vue&type=script&setup=true&lang=js"

import "./EventSearchWidget.vue?vue&type=style&index=0&id=870e91ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-870e91ae"]])

export default __exports__